module.exports = __webpack_public_path__ + "img/isupplier-logo.9e92acaf.png";